import { spawn } from 'redux-saga/effects';
import limitsSagas from './limits/limitsSagas';
import userSagas from './user/userSagas';

import { sagas as detailsSagas } from './detailsModule';

export default function* sagas() {
	yield spawn(detailsSagas);
	yield spawn(limitsSagas);
	yield spawn(userSagas);
}
